module.exports = __webpack_public_path__ + "img/appAsset--product-ax.dac99d76.svg";